import { render, staticRenderFns } from "./ChecklistImport.vue?vue&type=template&id=2b22a086&scoped=true&"
import script from "./ChecklistImport.vue?vue&type=script&lang=ts&"
export * from "./ChecklistImport.vue?vue&type=script&lang=ts&"
import style0 from "./ChecklistImport.vue?vue&type=style&index=0&id=2b22a086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22a086",
  null
  
)

export default component.exports